import { films, type Film } from '@/mocks/films';
import { newsList, type NewsItem } from '@/mocks/news';

export type { Film, NewsItem };

export const FILM_TYPES = ['电影', '电视剧', '综艺'];

export function getAllFilms(): Film[] {
  return films;
}

export function getFilmById(id: string | undefined): Film | undefined {
  if (!id) return undefined;
  return films.find((f) => f.id === id);
}

export function getNewsById(id: string | undefined): NewsItem | undefined {
  if (!id) return undefined;
  return newsList.find((n) => n.id === id);
}

export function getAllNews(): NewsItem[] {
  return [...newsList].sort((a, b) => (a.date < b.date ? 1 : -1));
}

export function searchFilms(keyword: string): Film[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return films.filter((f) => f.title.toLowerCase().includes(key));
}

export function getNewsByFilm(filmId: string): NewsItem[] {
  return getAllNews().filter((n) => n.relatedFilmId === filmId);
}

export function getRelatedFilms(film: Film, limit = 4): Film[] {
  return films
    .filter((f) => f.id !== film.id && (f.type === film.type || f.year === film.year))
    .slice(0, limit);
}

export function getLatestFilms(limit = 6): Film[] {
  return [...films]
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
    .slice(0, limit);
}

export function getYears(): number[] {
  const set = new Set(films.map((f) => f.year));
  return Array.from(set).sort((a, b) => b - a);
}

export function getTypeLabel(type: string): string {
  return type;
}